// 角色管理
export default {
    role: 'Role',
    roleName: 'Role Name',
    roleDescription: 'Role Description',
    userNumber: 'User Number',
    editRole: 'Edit Role',
    addRole: 'Add Role',
    rolePermissions: 'Role Permissions',
    tip_delete: 'After the character is deleted, it cannot be restored, please operate with caution!<br/>（The original user of this role only has the home page view function）',
}